/* eslint-disable no-undef */

const on = (
    event: string,
    ac: AbortController,
    callback: { (): void; (): void }
): void => {
    document.addEventListener(event, () => callback(), {
        signal: ac.signal,
    })
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
const dispatch = (event: string, data?: any): void => {
    document.dispatchEvent(new CustomEvent(event, { detail: data }))
}
const remove = (
    event: string,
    callback: EventListenerOrEventListenerObject
): void => {
    document.removeEventListener(event, callback)
}

const eventBus = { on, dispatch, remove }
export default eventBus
